import { Mail } from "lucide-react";

export function MobileContactButton() {
  return (
    <a
      href="mailto:info@upgradeskills.org"
      className="fixed bottom-20 right-4 z-40 md:hidden flex items-center justify-center w-14 h-14 rounded-full bg-gradient-hero shadow-button hover:shadow-lg transition-all"
      aria-label="Send us an email"
    >
      <Mail className="h-6 w-6 text-primary-foreground" aria-hidden="true" />
    </a>
  );
}